module.exports = __webpack_public_path__ + "static/its-sf-daaee55420f51b416f5556027f4d2764.png";